import { lazy, type ReactNode, Suspense } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import { AppProvider } from "./components/AppProvider";
import { ScrollToTop } from "./components/ScrollToTop";
import { userRoutes } from "./user-routes";

export const SuspenseWrapper = ({ children }: { children: ReactNode }) => {
  return <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>{children}</Suspense>;
};

export const router = createBrowserRouter([
  {
    element: (
      <AppProvider>
        <ScrollToTop />
        <SuspenseWrapper>
          <Outlet />
        </SuspenseWrapper>
      </AppProvider>
    ),
    children: userRoutes,
  },
]);

// HMR self-acceptance — tells Vite this module can be hot-swapped
// without a full page reload. Without this, every code change that
// transitively touches router.tsx (which is anything reachable from
// any page) triggers `[vite] page reload src/router.tsx` and wipes
// the user's session mid-edit. Routes themselves are stable so a
// no-op accept handler is safe — the worst case is that newly-added
// routes need a manual refresh once.
if (import.meta.hot) {
  import.meta.hot.accept();
}
